import FormMovimientoStock from "./events/FormMovimientoStock";
import FormProveedor from "./FormProveedor";
import FormStandard from "./FormStandard";
import FormVehiculo from "./FormVehiculo";
import FormPersona from "./FormPersona";
import FormTractor from "./FormTractor";
import FormAsignacion from "./FormAsignacion";
import FormEvents from "./FormEvents";
import FormFurgon from "./FormFurgon";
import FormStock from "./FormStock";
import FormMovimientoLlaves from "./events/FormMovimientoLlaves";
import FormMovimientoPorteria from "./events/FormMovimientoPorteria";
import FormMovimientoTrafico from "./events/FormMovimientoTrafico";

const FormGestor = ({
  tipo = "std",
  elemento = null,
  coleccion = null, // para formStandard
  area = null, // para formStandard
  filtroParaForm = null,
  /* `filtro` y `subFiltro` eligen QUÉ CAMPOS dibuja `FormEvents`
   * (`eventos[subFiltro || filtro || coleccion]`); `filtroParaForm` elige QUÉ
   * COMPONENTE. Son dos cosas distintas y sin reenviar las dos primeras el
   * formulario de un evento abría con cero campos — o sea, en blanco. */
  filtro = null,
  subFiltro = null,
  onGuardar,
  onClose,
  campoNoEditable = null,
}) => {
  const forms = {
    // elementos
    tractores: FormTractor,
    furgones: FormFurgon,
    vehiculos: FormVehiculo,
    personas: FormPersona,
    proveedores: FormProveedor,
    stock: FormStock,
    // eventos
    eventos: FormEvents,
    movStock: FormMovimientoStock,
    movPorteria: FormMovimientoPorteria,
    movLlaves: FormMovimientoLlaves,
    asignaciones: FormAsignacion,
    traficoSatelital: FormMovimientoTrafico,
    //repTractores: FormReparacionTractores,
    //repFurgones: FormReparacionFurgones,
  };

  const Component = forms[filtroParaForm || tipo] || FormStandard;

  return (
    <Component
      elemento={elemento}
      type={filtroParaForm || tipo}
      coleccion={coleccion}
      area={area}
      filtro={filtro}
      subFiltro={subFiltro}
      onGuardar={onGuardar}
      onClose={onClose}
      campoNoEditable={campoNoEditable}
    />
  );
};

export default FormGestor;
